import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkedAlt,
  faChartBar,
  faDatabase,
  faLocationDot,
  faBullseye,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

function GisSiderbar({ setActivePage, activePage }) {
  const [showTargetSubMenu, setShowTargetSubMenu] = useState(false);

  
  return (
    <aside id="myDIV" className="sidebar Gismapsidebar">
      <ul className="sidebar-nav" id="sidebar-nav">

        {/* GIS */}
         <li className={`nav-item ${activePage === "gis" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("gis")}>
            <i><FontAwesomeIcon icon={faMapMarkedAlt} /></i>
            <span> GIS Dashboard</span>
          </a>
        </li> 

        {/* Analytics */}
        <li className={`nav-item ${activePage === "analytics" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("analytics")}>
            <i><FontAwesomeIcon icon={faChartBar} /></i>
            <span> Scheme Dashboard</span>
          </a>
        </li>
        {/* Power BI Dashboard */}
        <li className={`nav-item ${activePage === "Powerbi" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("Powerbi")}>
            <i><FontAwesomeIcon icon={faChartBar} /></i>
            <span> Power BI Dashboard</span>
          </a>
        </li>

        {/* Survey */}
        <li className={`nav-item ${activePage === "survey" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("survey")}>
            <i><FontAwesomeIcon icon={faDatabase} /></i>
            <span> Survey Data Count</span>
          </a>
        </li>

        {/* Bhuvan */}
        {/* <li className={`nav-item ${activePage === "bhuvan" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("bhuvan")}>
            <i><FontAwesomeIcon icon={faLocationDot} /></i>
            <span> Bhuvan Map</span>
          </a>
        </li> */}

        {/* TARGET MONITORING */}
        <li className={`nav-item ${activePage === "assignTarget" ? "active" : ""}`}>
          <a
            className="nav-link d-flex justify-content-between align-items-center"
            onClick={() => {
              setActivePage("assignTarget");
              setShowTargetSubMenu(!showTargetSubMenu);
            }}
          >
         <span style={{ display: "flex" }}>
              <i><FontAwesomeIcon icon={faBullseye} /></i>
              <span > Target Monitoring <FontAwesomeIcon icon={faChevronDown} /></span>
            </span>
            
          </a>

          {/* SUB MENU */}
          {showTargetSubMenu && (
            <ul className="nav-content mt-2 red-left-list">
              <li>
                <a
                  // className="nav-link"
                  href="https://nfsm.gov.in/NewStateDemonstration.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NFSNM State Demostration
                </a>
              </li>
              <li>
                <a
                  // className="nav-link"
                  href="https://nfsm.gov.in/CFLDNewReportCropwise.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NFSNM CFLD
                </a>
              </li>
               <li>
                <a
                  // className="nav-link"
                  href="https://agriinfra.dac.gov.in/MISReports/ProjectTypeWiseMISReport"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  AIF
                </a>
              </li>
              <li>
                <a
                  // className="nav-link"
                  href="https://www.soilhealth.dac.gov.in/scheme-progress"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SHC
                </a>
              </li>


            </ul>
          )}
        </li>
         {/* <li className={`nav-item ${activePage === "BHUWAN_NEW_GEN" ? "active" : ""}`}>
          <a className="nav-link" onClick={() => setActivePage("BHUWAN_NEW_GEN")}>
            <i><FontAwesomeIcon icon={faLocationDot} /></i>
            <span>BHUVAN NEW GEN</span>
          </a>
        </li> */}

        

      </ul>
    </aside>
  );
}

export default GisSiderbar;